import slugify from 'slugify';

export class Slugify {

    constructor() {
    }

    public phrase(phrase: string): string {
        return slugify(phrase);
    }
}
